var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSToothBridgeMaryland(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 64 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconS-tooth-bridge-maryland",
    x: 0,
    y: 0,
    width: 64,
    height: 40,
    style: {
      fill: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconS-tooth-bridge-maryland1",
    serifid: "iconS-tooth-bridge-maryland"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.509,15.229c-1.036,2.79 -3.561,4.762 -6.509,4.762c-3.87,-0 -7.012,-3.399 -7.012,-7.585c0,-1.331 0.097,-3.214 1.94,-3.792c2.014,-0.632 8.13,-0.632 10.144,-0c1.843,0.578 1.94,2.461 1.94,3.792c-0,0.166 -0.005,0.331 -0.015,0.495l2.299,-0c-0.032,-0.919 0.044,-1.858 0.25,-2.81c0.622,-2.874 2.884,-5.187 5.631,-5.93c1.438,-0.38 2.824,-0.032 4.093,0.656l6.152,4.088c0.475,0.316 1.079,0.134 1.354,-0.309c0.291,-0.466 0.161,-1.091 -0.298,-1.399l-1.729,-1.147c0.214,-0.111 0.444,-0.198 0.643,-0.348c1.598,-1.217 3.481,-2.071 5.455,-1.542c2.747,0.743 4.971,3.065 5.631,5.93c0.209,0.906 0.256,1.861 0.189,2.811l2.336,-0c-0.01,-0.164 -0.015,-0.329 -0.015,-0.495c0,-1.331 0.097,-3.214 1.94,-3.792c2.014,-0.632 8.13,-0.632 10.144,-0c1.843,0.578 1.94,2.461 1.94,3.792c-0,4.186 -3.142,7.585 -7.012,7.585c-2.948,-0 -5.473,-1.972 -6.509,-4.762l-3.199,0c-0.522,2.11 -1.451,3.935 -2.175,4.762l-22.485,-0c-0.897,-1.426 -1.632,-3.037 -2.027,-4.762l-3.096,0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSToothBridgeMaryland);
export default __webpack_public_path__ + "static/media/iconS-tooth-bridge-maryland.29f03848e7578c20e24aeab51318e420.svg";
export { ForwardRef as ReactComponent };